const userClassAssignment = {
  PaypalFee: 'V',
};

export default userClassAssignment;



/** WEBPACK FOOTER **
 ** ./src/config/userClassAssignment.js
 **/